'use strict';
module.exports = ['$scope', '$state', '$q', '$sessionStorage', 'situationRecordService', 'toastService', 'situationRecordClass', 'clazzIconFilter'
            , 'translateFilter', '$window', 'errorHandlerService', 'sourceService', 'datex2EnumsService',
    function ($scope, $state, $q, $sessionStorage, situationRecordService, toastService, situationRecordClass, clazzIconFilter
            , translateFilter, $window, errorHandlerService, sourceService, datex2EnumsService) {


        //****************************************************************************************
        //                          CSV EXPORT
        //****************************************************************************************
        $scope.getCSVHeader = function () {
            return situationRecordClass.getCSVHeader();
        };

        $scope.getCSVData = function () {
            var deferred = $q.defer();

            $scope.searchSituationRecord($scope.curFilter, $scope.curPaginationPage, $scope.curPaginationSize, $scope.curPaginationSort).then(
                    function () {

                        var ret = situationRecordClass.getCSVData($scope.situationRecordSearch, $scope.situationRecordTypesTree.children, $scope.situationRecordSources, $scope.datex2Enums);
                        deferred.resolve(ret);
                    }
            , function (errors) {
                errorHandler(errors);
                deferred.reject();
            });

            return deferred.promise;

        };

        $scope.CSV = {
            separator: ";",
            filename: translateFilter('AstralSituationRecord.eventSearch') + ".csv"
        };
        //**************************************************************************************** 

        $scope.markers = [];
        $scope.directions = {};
        $scope.shapes = [];

        $scope.boxStatus = {
            mapIsOpen: true,
            dataIsOpen: true
        };

        $scope.myMap = {
            mapId: 'mapIndex',
            zoom: 11,
            centerLat: 41.89,
            centerLng: 12.5,
            showDrawing: false,
            enablePath: false,
            enableMarkerDraw: false,
            parentObjEditable: false,
            mapDivStyle: {height: '800px'},
            mapStyle: {
                height: '500px',
                width: '100%',
                position: 'relative',
                display: 'block'
            }
        };

        // show-hide map menu icon
        $scope.showMapLayer = {
            layerCotral: false,
            layerAtac: false,
            layerFerrovieStato: false,
            layerAeroporti1: false,
            layerAeroporti2: false,
            layerPorti1: false,
            layerPorti2: false,
            layerPorti3: false,
            layerTraffico: true,
            layerTransit: false,
            layerMeteo: false,
            layerTelecamereAstral: false,
            layerTelecamereAutostrade: false
        };

        var numMapLayers = 11;
        $scope.mapIdxLayerMapper = {
            mapIdxLayerCotral: 0,
            mapIdxLayerAtac: 1,
            mapIdxLayerFerrovieStato: 2,
            mapIdxLayerAeroporti1: 3,
            mapIdxLayerAeroporti2: 4,
            mapIdxLayerPorti1: 5,
            mapIdxLayerPorti2: 6,
            mapIdxLayerPorti3: 7,
            mapIdxLayerMeteo: 8,
            mapIdxLayerTelecamereAstral: 9,
            mapIdxLayerTelecamereAutostrade: 10
        };

        $scope.menuStatus = {
            isCollapsed: true
        };

//        $scope.mapMenuStatus = {
//            isCollapsed: true
//        };

        $scope.situationRecordTypesTree = undefined;

        $scope.curTotItems = 0;

        /**
         * Risultati ricerca
         */
        $scope.situationRecordSearch = undefined;
        /**
         * Sources
         */
        $scope.situationRecordSources = undefined;
        /**
         * Caricamento Situation Record Source
         * @return {deferred.promise}
         */
        function getSources() {
            var deferred = $q.defer();
            var params = {
                page: 0,
                size: 1000,
                sort: "comment.comment.keyword"
            };
            sourceService.getAll(params, function (res) {

                $scope.situationRecordSources = res.content;

                deferred.resolve();
            }, function (errors) {
                errorHandler(errors);

                deferred.reject();
            });
            return deferred.promise;
        }

        /**
         * Enumerazioni Datex2
         */
        $scope.datex2Enums = undefined;

        /**
         * Caricamento Enumerazioni Datex2
         * @return {deferred.promise}
         */
        function getDatex2Enums() {
            var deferred = $q.defer();
            datex2EnumsService.getDatex2Enums(function (res) {
                if (res) {
                    $scope.datex2Enums = angular.fromJson(res);
                }
                $scope.severityList = [];

                deferred.resolve();
            }, function (errors) {
                errorHandler(errors);

                deferred.reject();
            });
            return deferred.promise;
        }
        ;

        Date.prototype.addDays = function (days) {
            var dat = new Date(this.valueOf());
            dat.setDate(dat.getDate() + days);
            return dat;
        };


        $scope.mapLayers = [];

        function initMapLayers() {

            // RESET
            for (var i = 0; i < numMapLayers; i++) {

                var mapLayersItem = {
                    showLayer: false,
                    jsonLayer: [],
                    "icon": "",
                    idx: i
                };

                $scope.mapLayers.push(mapLayersItem);
            }

        }

        $scope.switchLayer = function (mapIdxLayer) {

            var showHide = false;

            switch (mapIdxLayer) {
                case $scope.mapIdxLayerMapper.mapIdxLayerCotral:
                    showHide = $scope.showMapLayer.layerCotral;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerAtac:
                    showHide = $scope.showMapLayer.layerAtac;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerFerrovieStato:
                    showHide = $scope.showMapLayer.layerFerrovieStato;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerAeroporti1:
                    showHide = $scope.showMapLayer.layerAeroporti1;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerAeroporti2:
                    showHide = $scope.showMapLayer.layerAeroporti2;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerPorti1:
                    showHide = $scope.showMapLayer.layerPorti1;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerPorti2:
                    showHide = $scope.showMapLayer.layerPorti2;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerPorti3:
                    showHide = $scope.showMapLayer.layerPorti3;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerMeteo:
                    // Meteo Epson ???
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerTelecamereAstral:
                    showHide = $scope.showMapLayer.layerTelecamereAstral;
                    break;

                case $scope.mapIdxLayerMapper.mapIdxLayerTelecamereAutostrade:
                    showHide = $scope.showMapLayer.layerTelecamereAutostrade;
                    break;
            }
            $scope.mapLayers[mapIdxLayer].showLayer = showHide;
        };

        function resetFilter() {
            var defaultFilter = {
                clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter
                , id: undefined
                , validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0) //richiesto da Rinaldi con mail del 6/4/2108
                , validityPeriodsDateEnd: new Date(3100, 1, 1, 0, 0, 0)
                , topLeft: {
                    x: -180,
                    y: 90,
                    z: null
                }
                , bottomRight: {
                    x: 180,
                    y: -90,
                    z: null
                }
                , eventType: undefined
                , createdDateStart: undefined
                , createdDateEnd: undefined
                , severity: undefined
                , validityStatus: undefined
                , probabilityOfOccurrence: undefined
                , confidentiality: undefined
                , cause: undefined
                , source: undefined
                , comment: undefined
                , isValid: true
            };

            $scope.curFilter = defaultFilter;
        }

        $scope.refreshData = function () {
            $scope.searchSituationRecord($scope.curFilter, $scope.curPaginationPage, $scope.curPaginationSize, $scope.curPaginationSort);
        };

        $scope.searchSituationRecord = function (filter, page, size, sort) {
            var deferred = $q.defer();

            //verifica dei filtri impostati
            if (!filter)
                filter = {};

            if (!filter.validityPeriodsDateStart)
                filter.validityPeriodsDateStart= new Date(1900, 1, 1, 0, 0, 0); //richiesto da Rinaldi con mail del 6/4/2108                
            if (!filter.validityPeriodsDateEnd)
                filter.validityPeriodsDateEnd= new Date(3100, 1, 1, 0, 0, 0);
            if (!filter.topLeft)
                filter.topLeft = {
                    x: -180,
                    y: 90,
                    z: null
                };
            if (!filter.bottomRight)
                filter.bottomRight = {
                    x: 180,
                    y: -90,
                    z: null
                };

            var params = {};
            if (page !== undefined && page)
                params.page = page - 1;
            if (size)
                params.size = size;
            if (sort)
                params.sort = sort;


            $scope.situationRecordSearch = [];

            situationRecordService.search(params, filter, function (res) {

                $scope.situationRecordSearch = res.content;
                $scope.curTotItems = res.totalElements;

                if (!$scope.situationRecordSearch || $scope.situationRecordSearch.length === 0) {
                    var msg = translateFilter('AstralSituationRecord.noResultFound');
                    $scope.curTotItems = 0;
                    toastService.createWarningToast(msg);
                } else {
                    // leggo le location
                    // e setto i marker
                    MarkerEventInitialize();
                }

                deferred.resolve();
            }, function (errors) {
                
                errorHandler(errors);
                deferred.reject();
            });
            return deferred.promise;
        };

        function MarkerEventInitialize() {
            if (!$scope.situationRecordSearch || $scope.situationRecordSearch.length === 0) {
                return;
            }
            var markers = [];
            angular.forEach($scope.situationRecordSearch, function (sr) {
                if (sr.location && sr.location.coordinates)
                {
                    var desc = "";
                    if (sr.comments && sr.comments.length > 0 && sr.comments[0].comment)
                    {
                        desc = sr.comments[0].comment;
                    }

                    var markerEvent = {
                        idevent: sr.id,
                        lon: sr.location.coordinates[0][0],
                        lat: sr.location.coordinates[0][1],
                        icon: clazzIconFilter(sr.clazz),
                        description: desc
                    };
                    markers.push(markerEvent);
                }
            });
            $scope.markers = markers;

            if ($scope.markers[0]) {
                $scope.myMap.centerLat = $scope.markers[0].lat;
                $scope.myMap.centerLng = $scope.markers[0].lon;
            }
         
        }


        $scope.mapShapes = function (shapes) {
            
        };

        $scope.mapDirections = function (route, waypoint) {
            
        };

        $scope.mapMarkers = function (markers) {
            
        };

        $scope.mapMarkerOpenEvent = function (marker) {
            $state.go('situation-record-mgmt', {id: marker.idevent});
        };

        $scope.mapBoundChangeEvent = function (mapbounds) {
            
        };

        function getSituationRecordTree() {
            var deferred = $q.defer();
            situationRecordService.situationRecordGetTypes(function (res) {
                $scope.situationRecordTypesTree = res;

                angular.forEach($scope.situationRecordTypesTree.children, function (item) {
                    setSituationRecordTypesAttr(item);
                });
                deferred.resolve();

            }, function (error) {
                //GESTIONE ERRORE
                errorHandler(error);
                deferred.reject();
            });
            return deferred.promise;
        }


        /**
         * Management errori di validaziione riscontrati al salvataggio
         * @return {undefined}
         */
        function errorHandler(error, successMessage, errorMessage) {
            var validationErrors = [];
            errorHandlerService.handle(error, successMessage, errorMessage).then(function (validErrors) {
                validationErrors = validErrors;
                if (validErrors)
                    toastService.createErrorToast(translateFilter('AstralSituationRecord.notValidParameter'));
            });

        }

        function setSituationRecordTypesAttr(item) {
            item.collapsed = false;
            if (item.children.length) {
                angular.forEach(item.children, function (child) {
                    setSituationRecordTypesAttr(child);
                });
            }
        }

        $scope.selectSituationRecordType = function (node) {

            if (!node.children || node.children.length === 0) {

                $state.go('situation-record-new', {situationRecordType: node});
            }
        };



        $scope.focusinControl = {};

        function setMapHeight() {

            var windowHeight = $(window).outerHeight();
            
            $scope.myMap.mapDivStyle.height = windowHeight - (windowHeight / 4.5);
            $scope.myMap.mapStyle.height = windowHeight - (windowHeight / 4.5);

        }

        $scope.mapReady = function () {
            $scope.focusinControl.resetMap();
        };

        //****************************************************************************************
        //                          COLLEGAMENTO SELEZIONE MAPPA/SELEZIONE TABELLA RISULTATI
        //****************************************************************************************

        /**
         * Situation Record Id selezionato sulla tabella risultati
         */
        $scope.tableActiveId = undefined;
        /**
         * Situation Record Id selezionato sulla mappa
         */
        $scope.mapActiveId = undefined;


        /**
         * Handler evento marker click
         * @param {type} marker
         * @return {undefined}
         */
        $scope.onMarkerClickEvent = function (marker) {
            if (marker && marker.idevent) {
                $scope.tableActiveId = marker.idevent;
                $scope.$apply();
            }
        };
        /**
         * Handler on-situation-record-selected sulla tabella risultati 
         * @param {type} item
         * @return {undefined}
         */
        $scope.onSRTableSelected = function (item) {
            if (item) {
                $scope.tableActiveId = item.id;
                $scope.mapActiveId = item.id;
            }
        };
        
        //****************************************************************************************

        (function init() {
            $scope.activeId = undefined;
            // SituationRecort tree
            getSituationRecordTree().then(function () {
                getSources().then(function () {
                    getDatex2Enums().then(function () {

                    });
                });

                resetFilter();
                setMapHeight();
                initMapLayers();

                // ricerca situation record con filtri di default
                $scope.searchSituationRecord($scope.curFilter, $scope.curPaginationPage, $scope.curPaginationSize, $scope.curPaginationSort).then(function () {

                });

                
            });
        })();

    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/index/indexCtrl.js
// module id = 237
// module chunks = 0